import { types } from 'mobx-state-tree';
import { SpatialReference } from './spatialReference';

export const PolygonGeometry = types.model('PolygonGeometry', {
  gid: types.maybeNull(types.string),
  spatialReference: SpatialReference,
  rings: types.array(types.array(types.array(types.number)))
});
